import { TextField, Grid, MenuItem } from '@mui/material';
import { getControlId } from '@veeva-ctv/utils';
import { FormikProps } from 'formik';
import { SiteApplicationInput } from '@/gql/graphql';
import StandardCountryStateProvinceInput from '@/components/StandardCountryStateProvinceInput';
import { UIOnlyFields } from '@/types';

interface PrivatePracticeFormProps {
  formik: FormikProps<UIOnlyFields & SiteApplicationInput>;
}

const PrivatePracticeForm = ({ formik }: PrivatePracticeFormProps) => {

  const handleOrgNameChange = (val: string) => {
    void formik.setFieldValue('organization', val);
    if (!formik.values.hasMultiLocations) {
      void formik.setFieldValue('name', val);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'organizationName' })}
          name="organization"
          label="Organization name*"
          fullWidth
          value={formik.values.organization}
          error={formik.touched.organization && Boolean(formik.errors.organization)}
          helperText={formik.touched.organization && formik.errors.organization}
          onChange={(e) => {
            handleOrgNameChange(e.target.value);
          }}
          onBlur={formik.handleBlur}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          id={getControlId({
            type: 'select',
            name: 'hasMultiLocations',
          })}
          name="hasMultiLocations"
          fullWidth
          select
          label="Does your site have multiple locations?*"
          value={formik.values.hasMultiLocations}
          onBlur={formik.handleBlur}
          onChange={(e) => {
            void formik.setFieldValue('hasMultiLocations', e.target.value === 'true');
            if (e.target.value === 'true') {
              void formik.setFieldValue('name', '');
            } else {
              void formik.setFieldValue('name', formik.values.organization);
            }
          }}>
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </TextField>
      </Grid>

      {formik.values.hasMultiLocations && (
        <>
          <Grid item xs={12}>
            <TextField
              id={getControlId({
                type: 'select',
                name: 'isUniqueSite',
              })}
              name="isUniqueSite"
              fullWidth
              select
              label="Is each location considered a separate site when working with sponsors/CROs?*"
              value={formik.values.isUniqueSite}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                void formik.setFieldValue('isUniqueSite', e.target.value === 'true');
              }}>
              <MenuItem value="true">Yes</MenuItem>
              <MenuItem value="false">No</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              id={getControlId({ type: 'text', name: 'name' })}
              name="name"
              label="What specific location or division are you signing up?*"
              fullWidth
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>
        </>
      )}

      <StandardCountryStateProvinceInput
        formik={formik}
        stateFieldName="stateProvince"
        countryFieldName="country"
        cityFieldName="city"
        addressFieldName='address1'
        postalCodeFieldName='postalCode'
      />

      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'url' })}
          name="url"
          label="Website*"
          fullWidth
          value={formik.values.url}
          error={formik.touched.url && Boolean(formik.errors.url)}
          helperText={formik.touched.url && formik.errors.url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </Grid>
    </>
  );
};

export default PrivatePracticeForm;
